// Need to use the React-specific entry point to import `createApi`
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

type PostResponse = Post[];

// Define a service using a base URL and expected endpoints
export const postApiSlice = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "https://www.spoclearn.com",
  }),
  reducerPath: "postApi",
  tagTypes: ["posts"],
  endpoints: (build) => ({
    getPosts: build.query<PostResponse, void>({
      query: () => {
        return `/blog/wp-json/spoc/v1/posts`;
      },
    }),
  }),
});

export const { useGetPostsQuery } = postApiSlice;
